import React, { useCallback, useEffect, useState } from 'react';
import { Box, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'dva';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { history } from 'umi';
import ClearIcon from '@material-ui/icons/Clear';
import AddStyled from './AddStyled';
import CampaignEquity from './campaignEquity/CampaignEquity';
import BaseInformation from './base_information/BaseInformation.jsx';
import ButtonGroup from './button_group/ButtonGroup';

const Add = () => {
  //国际化
  // const intl = useIntl();
  // const { formatMessage } = intl;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, control, register, errors, setValue, getValues } =
    useForm({});
  //获取参数
  const { status, cardType, id, detailId, type } =
    history?.location?.query || {};
  //编辑时拿到当前数据详情
  const activityGroupDetail =
    useSelector((state) => state.crowdAdd2?.activityInfo) || null;
  const [isSubmit, setIsSubmit] = useState(false);
  //用户选择优惠券信息
  const [couponList, setCouponList] = useState([]);
  const [couponData, setCouponData] = useState();
  const types = ['发放优惠券', '优惠券有效期调整', '优惠券失效调整'];

  // 获取优惠券详情信息
  const fetchCouponDetail = useCallback(() => {
    detailId &&
      dispatch({
        type:
          type === '发放优惠券'
            ? 'crowdAdd2/getCouponDetail'
            : 'crowdAdd2/getAdjustCouponList',
        payload: {
          values: {
            id: detailId,
          },
        },
        callback: (res) => {
          const list =
            type === '发放优惠券'
              ? res.data.couponInfo
              : res.data.originalCouponInfo.coupons;
          setCouponList(list);
          setValue('remark', res.data.remark);
          setCouponData(res.data);
        },
      });
  }, [dispatch, detailId, setValue]);
  useEffect(() => {
    fetchCouponDetail();
  }, [fetchCouponDetail]);

  // 获取会员基本详情信息
  const fetchMemberDetail = useCallback(() => {
    id &&
      dispatch({
        type: 'crowdAdd2/getMemberDetail',
        payload: {
          values: {
            memberID: id,
          },
        },
      });
  }, [dispatch, id]);
  useEffect(() => {
    fetchMemberDetail();
  }, [fetchMemberDetail]);
  const memberDetail = useSelector((state) => {
    return state?.crowdAdd2?.memberDetail;
  });

  const handleSubmitFailed = () => {};

  //关于新增人群
  const handleSubmitSuccess = (data) => {
    const { memberCode } = history?.location?.query || {};
    let values = {
      couponSourceType: 'JOB_APPROVAL',
      memberCode,
      memberId: id,
      type: 'COUPON',
      mobile: memberDetail?.mobile,
      value: 'COUPON',
      coupons: couponList,
      remark: data?.remark,
    };
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    dispatch({
      type: 'crowdAdd2/postManualOperation',
      payload: {
        values,
      },
      callback: (res) => {
        if (res.code !== 0) {
          setIsSubmit(false);
          return;
        }
        window.message.toast({
          type: 'success',
          message: '发放优惠券成功',
          title: '',
        });
        setTimeout(() => {
          setIsSubmit(false);
          history.goBack();
        }, 2000);
      },
    });
  };
  return (
    <AddStyled>
      <BaseInformation memberDetail={memberDetail} />
      <Box>
        <FormProvider {...methods}>
          <form
            onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFailed)}
          >
            <Box className="form-wrapper">
              <Box
                sx={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: '#212121',
                  marginBottom: type === '优惠券失效调整' ? '4px' : '-4px',
                }}
              >
                {type === '发放优惠券' ? '发放优惠券' : '原优惠券信息'}
              </Box>
              {type === '优惠券失效调整' && (
                <Box
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#212121',
                    marginBottom: '-4px',
                  }}
                >
                  以下优惠券状态被调整为“已失效”
                </Box>
              )}
              <CampaignEquity
                cardType={cardType}
                status={status}
                control={control}
                activityGroupDetail={activityGroupDetail}
                setValues={setValue}
                couponList={couponList}
                setCouponList={setCouponList}
                register={register}
                errors={errors}
                type={type}
              />
              {type === '优惠券有效期调整' && (
                <Box mt={7} marginBottom="5px">
                  <Box
                    sx={{
                      fontSize: '18px',
                      fontWeight: 600,
                      color: '#212121',
                      marginBottom: '-4px',
                    }}
                  >
                    发放优惠券
                  </Box>
                  <Box display="flex" gap="112px" mt={4}>
                    <Box>
                      <Box
                        sx={{
                          fontSize: '12px',
                          color: '#212121',
                          fontWeight: 400,
                        }}
                      >
                        用券开始时间调整
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#212121',
                          fontWeight: 400,
                          marginTop: '14px',
                        }}
                      >
                        {
                          couponData?.originalCouponInfo?.startTime?.split(
                            ' ',
                          )?.[0]
                        }
                      </Box>
                    </Box>
                    <Box>
                      <Box
                        sx={{
                          fontSize: '12px',
                          color: '#212121',
                          fontWeight: 400,
                        }}
                      >
                        用券结束时间调整
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#212121',
                          fontWeight: 400,
                          marginTop: '14px',
                        }}
                      >
                        {
                          couponData?.originalCouponInfo?.endTime?.split(
                            ' ',
                          )?.[0]
                        }
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
              {types.includes(type) && (
                <Box mt={7}>
                  <Box sx={{ color: '#616161', fontSize: '12px' }}>
                    {type === '发放优惠券' ? '发放原因' : '调整原因'}
                  </Box>
                  <Box
                    sx={{
                      color: '#212121',
                      fontSize: '14px',
                      marginTop: '6px',
                    }}
                  >
                    {couponData?.remark}
                  </Box>
                </Box>
              )}
              {!types.includes(type) && (
                <Box width={360} mt={7}>
                  <Controller
                    render={(pr) => (
                      <TextField
                        disabled={status === 'detail'}
                        onChange={(e) => {
                          return pr.onChange(e.target.value);
                        }}
                        InputProps={
                          status !== 'detail' && {
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  className="clear-btn"
                                  onClick={() => {}}
                                  edge="end"
                                >
                                  {getValues('remark') ? (
                                    <ClearIcon className="clear-icon" />
                                  ) : (
                                    ''
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }
                        }
                        variant="standard"
                        className="input"
                        value={pr.value ?? ''}
                        label="发放原因"
                      />
                    )}
                    name="remark"
                    control={control}
                    defaultValue=""
                  />
                </Box>
              )}
            </Box>

            <ButtonGroup control={control} />
          </form>
        </FormProvider>
      </Box>
    </AddStyled>
  );
};
export default Add;
